import styled from 'styled-components';
import { colors, breakPoints } from '@/styles';
// import { Card } from '@/ui/primatives';

export const BranchCreateModal = styled.div`
  /* gap: 10px; */
  min-width: 400px;
  background-color: ${colors.secondary.lightGray1};
  border-radius: 10px;

  & > * {
    padding: 10px 20px;
  }

  @media (max-width: ${breakPoints.mobile}) {
    position: fixed;
    border-radius: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    min-width: 100vw;
    max-width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
  }
`;

export const ModalHeader = styled.h6`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${colors.secondary.lightGray3};
`;

export const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
  background-color: ${colors.primary.white};
  @media (max-width: ${breakPoints.mobile}) {
    flex: 1;
  }
`;

export const ModalFooter = styled.h6`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  align-items: center;
  border-top: 1px solid ${colors.secondary.lightGray3};
`;
